import { defaultKavaProviderConfiguration } from 'src/features/on-chain/calculation-manager/providers/dexes/kava/default-constants';

export const JUPITER_SWAP_CONTRACT_ADDRESS = '0xEa3CB4Ba9d1fD6fb19Df1380958d5649bD3e7C50';

export const JUPITER_SWAP_PROVIDER_CONFIGURATION = defaultKavaProviderConfiguration;
